.topBadge {
    composes: fontEyebrow from "../../styles/composable/typography.module.css";
    margin-bottom: var(--spacer-8);
}

.bottomBadge {
    composes: fontCaption from "../../styles/composable/typography.module.css";
    display: inline-block;
    padding: 6px var(--spacer-8) var(--spacer-4);
    background-color: var(--red);
    color: var(--white);
}

.bottomGrayBadge {
    composes: bottomBadge;
    background-color: var(--gray);
    color: var(--white);
}
